/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Import global stylesheet to override user agent styles
import '@fontsource/open-sans'; // npm package of Google's Open Sans font
import './src/styles/global.css';
